module.exports = __webpack_public_path__ + "static/media/ontvangen_color.383cd676.svg";